import React from "react";
import styles from '../components/index.module.css';
import InfoBox from '../components/info.js'
import PhotoBas from './../../images/A2Bas_N010287.jpg'
import Panoramic from "../components/panoramic.js";

export default () => (
    <Panoramic>
        <div className='metadata--wrapper'>
            <img src={PhotoBas} alt="" />
            <InfoBox>Le Palais Montcalm et la Place d&#39;Youville. Photographe inconnu, Fonds de la Ville de Québec, AVQ, ca1935.</InfoBox>
        </div>
    </Panoramic>
);



// WEBPACK FOOTER //
// ./src/components/image-footer-axe2.js